import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/style/header.scss';
import 'font-awesome/css/font-awesome.min.css';
import './assets/style/body.scss';
// import './assets/style/rsuit.css';
import 'typeface-ibm-plex-sans'
import "@fontsource/poppins";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { BrowserRouter as Router } from 'react-router-dom'
import store from './store/store';
import { Provider } from 'react-redux';
import './icons-1/bootstrap-icons.css';
// import './style-custom3.css';


ReactDOM.render(
  <Provider store={store}>
       <Router>
      <App />
      </Router>
    </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
